// The Resources menu, for the header and the footer. Names and paths only, so
// the header doesn't load guide copy. docs/refresh/COPY_DECK.md "Guides ›
// Changes to existing pages and navigation".

export const RESOURCES_MENU = 'Resources';

export const RESOURCE_LINKS = [
  { label: 'Guides', to: '/guides' },
  { label: 'Due Diligence Checklist', to: '/guides/due-diligence-checklist' },
  { label: 'Glossary', to: '/glossary' },
];

// The menu's links count as one section for the header's active underline.
export const isResourcesPath = (pathname) =>
  pathname === '/guides' || pathname.startsWith('/guides/') || pathname === '/glossary';
